import React from 'react'
import Cruise from '../types/Cruise'
import Ship from '../types/Ship'
import Stopover from '../types/Stopover'
import { isShip, isStopover } from '../utils/types'
import ShipInfo from './ShipInfo'
import StopoverInfo from './StopoverInfo'

type Props = {
  item: Stopover | Ship | null

  closeModal: () => void

  setCruise: (cruise: Cruise) => void

  cleanItem: () => void
}

const ModalInfo: React.FC<Props> = ({ item, closeModal, setCruise, cleanItem }: Props) => {
  if (item === null) {
    return null
  }
  if (isStopover(item)) {
    return <StopoverInfo closeModal={closeModal} item={item} />
  }

  if (isShip(item)) {
    return (
      <ShipInfo closeModal={closeModal} item={item} setCruise={setCruise} cleanItem={cleanItem} />
    )
  }

  return null
}

export default ModalInfo
